import styles from "./styles.scss";

const TextLogo = () => {
  return (
    <div className={styles.root}>
      <img
        src="/images/logo_horizontal.svg"
        className={styles.logoHorizontal}
        alt="Studyplus for School"
      />
    </div>
  );
};

export default TextLogo;
